import {Injectable} from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import {catchError, Observable, of} from 'rxjs';
import {Router} from "@angular/router";
import {Emittable, Emitter} from "@ngxs-labs/emitter";
import {DataState} from "../store/data.state";
import {ERROR_STATUSES, HTTP_CODES, INVALID_REQUEST} from "./errors-def";

@Injectable()
export class DataErrorInterceptor implements HttpInterceptor {
  @Emitter(DataState.changeScreenPath) private changeFlow!: Emittable<string>;
  @Emitter(DataState.setErrorCode) private setErrorCode!: Emittable<number>;
  @Emitter(DataState.saveFlowId)
  private saveFlowId!: Emittable<string | null>;

  constructor(private readonly _router: Router) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        if (err instanceof HttpErrorResponse) {
          if (HTTP_CODES.includes(err.status)) {
            this.setErrorCode.emit(err.error.code);
            if (ERROR_STATUSES.includes(err.error.code)) {
              this.errorRedirect(err.error.code);
            }

            if (INVALID_REQUEST.includes(err.error.code)) {
              this.saveFlowId.emit(null);
              this.errorRedirect(err.error.code);
            }
          }
        }
        throw of(err);
      }))
  }

  private errorRedirect(code: string) {
    this.changeFlow.emit('/error');
    this._router.navigate(['/error'], {queryParams: {code: code}});
    return of(new HttpResponse());
  }
}


